import { render, staticRenderFns } from "./OrderActivityLogs.vue?vue&type=template&id=5f9fb77c&scoped=true"
import script from "./OrderActivityLogs.vue?vue&type=script&lang=js"
export * from "./OrderActivityLogs.vue?vue&type=script&lang=js"
import style0 from "./OrderActivityLogs.vue?vue&type=style&index=0&id=5f9fb77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9fb77c",
  null
  
)

export default component.exports